module.exports = __webpack_public_path__ + "static/img/success9.7f285c1a.jpg";